import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CheckMarkIcon } from '../../../../../../resources/assets/components/DLS_Checkmark.svg';
import './wizard-horizontal-header-step.css';
function WizardHorizontalHeaderStep(props) {
    const horizontalHeaderStepClassName = classNames({
        'c-wizard-horizontal-header-step': true,
        'c-wizard-horizontal-header-step--current': props.currentStep,
        'c-wizard-horizontal-header-step--disabled': !props.enabled && !props.readOnly,
        'c-wizard-horizontal-header-step--done': props.done || props.readOnly,
        'c-wizard-horizontal-header-step--first': props.first,
        'c-wizard-horizontal-header-step--last': props.last,
        'c-wizard-horizontal-header-step--read-only': props.readOnly,
        'c-wizard-horizontal-header-step--small': props.small,
    });
    const title = MessageService.translate(props.title);
    return (React.createElement("div", { "aria-label": title, className: horizontalHeaderStepClassName, "data-step-title": props.small ? '' : title, "data-wizard-step-identifier": props.identifier, role: "marquee" },
        React.createElement("div", { className: "c-wizard-horizontal-header-step__index" }, !props.first && !props.last && !props.readOnly && props.done
            ? React.createElement(CheckMarkIcon, { className: "c-wizard-horizontal-header-step__checkmark" })
            : props.displayIndex)));
}
export { WizardHorizontalHeaderStep, };
//# sourceMappingURL=wizard-horizontal-header-step.js.map